// // import React from "react";
// // import { Typography, Grid, Button } from "@mui/material";
// // import "../Header/header.css";

// // import Navbar from "../navbar";
// // import Footer from "../Footer";

// // const Prayer = () => {
// //   const table = [
// //     { name: "Day" },
// //     { name: "June" },
// //     { name: "Hijri" },
// //     { name: "Fajr" },
// //     { name: "Sunrise" },
// //     { name: "Dhuhr" },
// //     { name: "Asr" },
// //     { name: "Maghrib" },
// //     { name: "Isha" },
// //   ];

// import * as React from "react";
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableCell from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TableRow from "@mui/material/TableRow";
// import Paper from "@mui/material/Paper";

// function createData(
//   Day,
//   June,
//   Hijri,
//   Fajr,
//   Sunrise,
//   Dhuhr,
//   Asr,
//   Maghrib,
//   Isha
// ) {
//   return { Day, June, Hijri, Fajr, Sunrise, Dhuhr, Asr, Maghrib, Isha };
// }

// const rows = [
//   createData(
//     "Tue",
//     "1",
//     "13 / 4",
//     "3:30",
//     "5:09",
//     "12:40",
//     "4:41",
//     "8:11",
//     "9:51"
//   ),
//   createData(
//     "Wed",
//     "2",
//     "14 / 4",
//     "3:29",
//     "5:08",
//     "12:40",
//     "4:42",
//     "8:12",
//     "9:52"
//   ),
//   createData(
//     "Thu",
//     "3",
//     "15 / 4",
//     "3:28",
//     "5:08",
//     "12:40",
//     "4:42",
//     "8:12",
//     "9:53"
//   ),
//   createData(
//     "Fri",
//     "4",
//     "16 / 4",
//     "3:28",
//     "5:08",
//     "12:41",
//     "4:42",
//     "8:13",
//     "9:54"
//   ),
//   createData(
//     "Sat",
//     "5",
//     "17/4",
//     "3:27",
//     "5:07",
//     "12:41",
//     "4:43",
//     "8:14",
//     "9:55"
//   ),
//   createData(
//     "Sun",
//     "6",
//     "18/4",
//     "3:26",
//     "5:07",
//     "12:41",
//     "4:43",
//     "8:14",
//     "9:56"
//   ),
//   createData(
//     "Mon",
//     "7",
//     "19/4",
//     "3:26",
//     "5:07",
//     "12:41",
//     "4:43",
//     "8:15",
//     "9:56"
//   ),
//   createData(
//     "Tue",
//     "8",
//     "20/4",
//     "3:26",
//     "5:07",
//     "12:41",
//     "4:43",
//     "8:15",
//     "9:57"
//   ),
//   createData(
//     "Wed",
//     "9",
//     "21/4",
//     "3:25",
//     "5:06",
//     "12:42",
//     "4:44",
//     "8:16",
//     "9:58"
//   ),
//   createData(
//     "Thu",
//     "10",
//     "22/4",
//     "3:25",
//     "5:06",
//     "12:42",
//     "4:44",
//     "8:17",
//     "9:59"
//   ),
//   createData(
//     "Fri",
//     "11",
//     "23/4",
//     "3:25",
//     "5:06",
//     "12:42",
//     "4:44",
//     "8:17",
//     "9:59"
//   ),
//   createData(
//     "Sat",
//     "12",
//     "24/4",
//     "3:24",
//     "5:06",
//     "12:42",
//     "4:44",
//     "8:18",
//     "10:00"
//   ),
//   createData(
//     "Sun",
//     "13",
//     "25/4",
//     "3:24",
//     "5:06",
//     "12:42",
//     "4:45",
//     "8:18",
//     "10:01"
//   ),
//   createData(
//     "Mon",
//     "14",
//     "26/4",
//     "3:24",
//     "5:06",
//     "12:43",
//     "4:45",
//     "8:18",
//     "10:01"
//   ),
//   createData(
//     "Tue",
//     "15",
//     "27/4",
//     "3:24",
//     "5:06",
//     "12:43",
//     "4:45",
//     "8:19",
//     "10:02"
//   ),
//   createData(
//     "Wed",
//     "16",
//     "28/4",
//     "3:24",
//     "5:06",
//     "12:43",
//     "4:45",
//     "8:19",
//     "10:02"
//   ),
//   createData(
//     "Thu",
//     "17",
//     "29/4",
//     "3:24",
//     "5:06",
//     "12:43",
//     "4:46",
//     "8:19",
//     "10:03"
//   ),
//   createData(
//     "Fri",
//     "18",
//     "30/4",
//     "3:24",
//     "5:06",
//     "12:43",
//     "4:46",
//     "8:20",
//     "10:03"
//   ),
//   createData(
//     "Sat",
//     "19",
//     "1/5",
//     "3:24",
//     "5:06",
//     "12:44",
//     "4:46",
//     "8:20",
//     "10:03"
//   ),
//   createData(
//     "Sun",
//     "20",
//     "2/5",
//     "3:24",
//     "5:07",
//     "12:44",
//     "4:46",
//     "8:20",
//     "10:03"
//   ),
//   createData(
//     "Mon",
//     "21",
//     "3/5",
//     "3:25",
//     "5:07",
//     "12:44",
//     "4:47",
//     "8:20",
//     "10:04"
//   ),
//   createData(
//     "Tue",
//     "22",
//     "4/5",
//     "3:25",
//     "5:07",
//     "12:44",
//     "4:47",
//     "8:21",
//     "10:04"
//   ),
//   createData(
//     "Wed",
//     "23",
//     "5/5",
//     "3:25",
//     "5:07",
//     "12:45",
//     "4:47",
//     "8:21",
//     "10:04"
//   ),
//   createData(
//     "Thu",
//     "24",
//     "6/5",
//     "3:26",
//     "5:08",
//     "12:45",
//     "4:47",
//     "8:21",
//     "10:04"
//   ),
//   createData(
//     "Fri",
//     "25",
//     "7/5",
//     "3:26",
//     "5:08",
//     "12:45",
//     "4:47",
//     "8:21",
//     "10:04"
//   ),
//   createData(
//     "Sat",
//     "26",
//     "8/5",
//     "3:27",
//     "5:08",
//     "12:45",
//     "4:48",
//     "8:21",
//     "10:04"
//   ),
//   createData(
//     "Sun",
//     "27",
//     "9/5",
//     "3:27",
//     "5:09",
//     "12:45",
//     "4:48",
//     "8:21",
//     "10:04"
//   ),
//   createData(
//     "Mon",
//     "28",
//     "10/5",
//     "3:28",
//     "5:09",
//     "12:46",
//     "4:48",
//     "8:21",
//     "10:03"
//   ),
//   createData(
//     "Tue",
//     "29",
//     "11/5",
//     "3:28",
//     "5:10",
//     "12:46",
//     "4:48",
//     "8:21",
//     "10:03"
//   ),
//   createData(
//     "Wed",
//     "30",
//     "12/5",
//     "3:29",
//     "5:10",
//     "12:46",
//     "4:48",
//     "8:21",
//     "10:03"
//   ),
// ];

// export default function DenseTable() {
//   return (
//     <TableContainer
//       sx={{
//         background: "#f3fff9",
//         width: "80%",
//         display: "block",
//         marginLeft: "auto",
//         marginRight: "auto",
//         marginTop: "10px",
//         marginBotttom: "10px",
//       }}
//       component={Paper}
//     >
//       <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
//         <TableHead>
//           <TableRow>
//             <TableCell sx={{ fontWeight: "700" }}>Day</TableCell>
//             <TableCell sx={{ fontWeight: "700" }} align="right">
//               June
//             </TableCell>
//             <TableCell sx={{ fontWeight: "700" }} align="right">
//               Hijri
//             </TableCell>
//             <TableCell sx={{ fontWeight: "700" }} align="right">
//               Fajr
//             </TableCell>
//             <TableCell sx={{ fontWeight: "700" }} align="right">
//               Sunrise
//             </TableCell>
//             <TableCell sx={{ fontWeight: "700" }} align="right">
//               Dhuhr
//             </TableCell>
//             <TableCell sx={{ fontWeight: "700" }} align="right">
//               Asr
//             </TableCell>
//             <TableCell sx={{ fontWeight: "700" }} align="right">
//               Maghrib
//             </TableCell>
//             <TableCell sx={{ fontWeight: "700" }} align="right">
//               Isha
//             </TableCell>
//           </TableRow>
//         </TableHead>
//         <TableBody>
//           {rows.map((row) => (
//             <TableRow
//               key={row.name}
//               sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
//             >
//               <TableCell component="th" scope="row">
//                 {row.Day}
//               </TableCell>
//               <TableCell align="right">{row.June}</TableCell>
//               <TableCell align="right">{row.Hijri}</TableCell>
//               <TableCell align="right">{row.Fajr}</TableCell>
//               <TableCell align="right">{row.Sunrise}</TableCell>
//               <TableCell align="right">{row.Dhuhr}</TableCell>
//               <TableCell align="right">{row.Asr}</TableCell>
//               <TableCell align="right">{row.Maghrib}</TableCell>
//               <TableCell align="right">{row.Isha}</TableCell>
//             </TableRow>
//           ))}
//         </TableBody>
//       </Table>
//     </TableContainer>
//   );
// }

import { Grid, Typography } from "@mui/material";
import React from "react";

function PrayerTimer() {
  return (
    <>
      <Typography
        sx={{
          textAlign: "center",
          paddingTop: "50px",
          fontSize: "30px",
          fontWeight: "bold",
        }}
      >
        Namaz Time Table
      </Typography>
      <Grid
        container
        sx={{
          display: "flex",
          justifyContent: "center",
          paddingTop: "20px",
        }}
      >
        <Grid
          item
          xs={5}
          md={3}
          sx={{ border: "2px solid black", textAlign: "center" }}
        >
          <Typography
            sx={{
              fontWeight: "bold",
              borderBottom: "1px solid",
              padding: "10px",
            }}
          >
            FAJR
          </Typography>
          <Typography
            sx={{
              fontWeight: "bold",
              borderBottom: "1px solid",
              padding: "10px",
            }}
          >
            ZUHAR
          </Typography>
          <Typography
            sx={{
              fontWeight: "bold",
              borderBottom: "1px solid",
              padding: "10px",
            }}
          >
            ASAR
          </Typography>
          <Typography
            sx={{
              fontWeight: "bold",
              borderBottom: "1px solid",
              padding: "10px",
            }}
          >
            MAGRIB
          </Typography>
          <Typography
            sx={{
              fontWeight: "bold",
              padding: "10px",
            }}
          >
            ISHA
          </Typography>
        </Grid>
        <Grid
          item
          xs={5}
          md={3}
          sx={{ border: "2px solid black", textAlign: "center" }}
        >
          <Typography
            sx={{
              fontWeight: "bold",
              borderBottom: "1px solid",
              padding: "10px",
            }}
          >
            5:30
          </Typography>
          <Typography
            sx={{
              fontWeight: "bold",
              borderBottom: "1px solid",
              padding: "10px",
            }}
          >
            1:30
          </Typography>
          <Typography
            sx={{
              fontWeight: "bold",
              borderBottom: "1px solid",
              padding: "10px",
            }}
          >
            5:30
          </Typography>
          <Typography
            sx={{
              fontWeight: "bold",
              borderBottom: "1px solid",
              padding: "10px",
            }}
          >
            6:30
          </Typography>
          <Typography
            sx={{
              fontWeight: "bold",
              padding: "10px",
            }}
          >
            8:45
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}

export default PrayerTimer;
